export function getFbp(cookieStr: string): string | undefined {
  return /(?:[\s;]|^)_fbp\s*=\s*([^;$]+)/.exec(cookieStr)?.[1];
}
